import { Pipe, PipeTransform } from '@angular/core';
import { EmailTemplateBasicsItem } from '../models/domain/email.template.basics.item';

@Pipe({
    name: 'emailTemplateFilter',
    pure: false
})

export class EmailTemplateFilterPipe implements PipeTransform {
    transform(items: EmailTemplateBasicsItem[], searchText: string): EmailTemplateBasicsItem[] {
        if (!items) return [];
        if (!searchText) return items;
        searchText = searchText.toLowerCase();

        return items.filter(it => {
            return it.Name.toLowerCase().includes(searchText);
        });
    }
}
